import { Modal } from "@portal/components/layout/Modal";
import { ModalItemWithHeader } from "@portal/components/layout/ModalItemWithHeader";
import { Text } from "@portal/components/primitives";
import {
	fraudWarningsIntro,
	fraudWarningsNoticeTitle,
	fraudWarningsStatements,
} from "./fraudWarningsContent";

type FraudWarningsModalProps = {
	onClose: () => void;
};

export const FraudWarningsModal = ({ onClose }: FraudWarningsModalProps) => (
	<Modal onClickOutside={onClose} itemClassName="w-full">
		<div className="contents" onWheel={(event) => event.stopPropagation()}>
			<ModalItemWithHeader
				header={fraudWarningsNoticeTitle}
				onClose={onClose}
				className="w-full max-w-[min(900px,92vw)] max-h-[min(85vh,900px)]"
				bodyClassName="min-h-0 overflow-y-auto overscroll-contain"
			>
				<div className="flex flex-col gap-[36px] p-[24px]">
					<div className="flex flex-col gap-[16px]">
						<Text type="title" color="primary">
							State Fraud Warnings
						</Text>
						<Text type="body" color="secondary">
							{fraudWarningsIntro}
						</Text>
					</div>
					<div className="flex flex-col gap-[36px]">
						{fraudWarningsStatements.map(({ title, body }) => (
							<section key={title} className="flex flex-col gap-[16px]">
								<Text type="body-strong" color="primary">
									{title}
								</Text>
								<Text type="body" color="secondary" className="whitespace-pre-line">
									{body}
								</Text>
							</section>
						))}
					</div>
				</div>
			</ModalItemWithHeader>
		</div>
	</Modal>
);
